// extracted by mini-css-extract-plugin
export default {"root":"FLightHitContent__root--Duovn"};